module.exports = __webpack_public_path__ + "img/register.1d05dbd4.svg";